import { render } from "./StoreDetails.vue?vue&type=template&id=a723b584"
import script from "./StoreDetails.vue?vue&type=script&lang=js"
export * from "./StoreDetails.vue?vue&type=script&lang=js"

import "./StoreDetails.vue?vue&type=style&index=0&id=a723b584&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__